<template>
    <div class="progress-question">
        <h2>
            <span v-if="progressStep > 2">{{ groupName }}</span
            >{{ mainText }}
        </h2>
        <h3 v-html="tt(subText)"></h3>
    </div>
</template>

<script>
export default {
    name: 'ProgressQuestion',
    props: {
        progressStep: {
            type: Number,
            default: 1,
        },
        groupName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {}
    },
    computed: {
        mainText() {
            if (this.progressStep === 1) {
                return `기관명을 입력해주세요.`
            } else if (this.progressStep === 2) {
                return `그룹명을 입력해주세요.`
            } else if (this.progressStep === 3) {
                return `에서 사용하고 계신 보관함을 등록해 주세요.`
            } else {
                return `에 소속된 멤버를 초대해 주세요.`
            }
        },
        subText() {
            if (this.progressStep === 1) {
                return `기관명은 기업, 대학, 연구소, 공공기관 등의 이름을 의미합니다.<br>(예: 스마트잭)`
            } else if (this.progressStep === 2) {
                return `그룹명은 팀, 부서, 연구실 등의 이름을 의미합니다.<br>(예: 그린촉매연구실)`
            } else if (this.progressStep === 3) {
                return `물품을 등록할 보관함을 추가해 주세요.<br>(예: 위험물보관함)`
            } else {
                return ``
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.progress-question {
    width: 100%;
    // h1 {
    //     font-size: 1.375rem;
    //     font-weight: 700;
    //     background: linear-gradient(180deg, #fec741 0%, #ffa90b 100%);
    //     -webkit-background-clip: text;
    //     -webkit-text-fill-color: transparent;
    //     background-clip: text;
    //     text-fill-color: transparent;
    //     display: inline-block;
    // }
    h2 {
        font-size: 1.375rem;
        font-weight: 700;
        display: inline-block;
        line-height: 1.4;
        letter-spacing: -0.02rem;
        word-break: keep-all;
        width: 100%;
        span {
            font-size: 1.375rem;
            font-weight: 700;
            background: linear-gradient(180deg, #fec741 0%, #ffa90b 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            display: inline-block;
            max-width: 85%;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: -6px;
            overflow: hidden;
        }
    }
    h3 {
        font-size: 0.875rem;
        color: #999;
        font-weight: 400;
        margin-top: 10px;
        margin-bottom: 20px;
    }
}
</style>
